import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {FeatureGate, LIMITED_CSV_EXPORT_PROJECTS, ProjectFeatureFlag} from 'common/report/constants';

export function isCustomCsvLimitEnabled(project: CurrentProject | ProjectDetails | undefined): boolean | undefined {
  return (
    project?.hasFeatureFlag(ProjectFeatureFlag.CustomCsvLimit) &&
    project?.getFeatureGate(FeatureGate.CanCustomizeCsvLimit) &&
    !LIMITED_CSV_EXPORT_PROJECTS.has(project?.id.toString())
  );
}
